import React from "react";

import FancyButton from "../components/FancyButton";
import usePageMeta from "../hooks/usePageMeta";
import "./styles.css";

export default function NotFound() {
	usePageMeta("Page not found");

	return (
		<main id="main-content" tabIndex={-1} className="not-found">
			<h1 className="page-title black-text">Not found</h1>
			<p className="sm black">
				This page doesn’t exist or has moved.
			</p>
			<div className="hero-actions">
				<FancyButton label="Go home" linkTo="/" black />
				<FancyButton label="See my work" linkTo="/work" />
			</div>
		</main>
	);
}
